import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import api from '../../utils/api';

const Login: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const { data } = await api.post('/auth/login', formData);
      if (!mountedRef.current) return;
      localStorage.setItem('token', data.token);
      dispatch({ type: 'LOGIN_SUCCESS', payload: data });
      history.push('/');
    } catch (err: any) {
      if (!mountedRef.current) return;
      setError(err.response?.data?.message || '登录失败，请重试');
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  };

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={handleSubmit}>
        <h2 className="auth-title">登录</h2>
        
        {error && (
          <div style={{ 
            color: '#ff4d4f', 
            marginBottom: '16px', 
            padding: '8px',
            background: '#fff2f0',
            borderRadius: '4px'
          }}>
            {error}
          </div>
        )}

        <div className="form-group">
          <label className="form-label">邮箱</label>
          <input
            type="email"
            className="form-input"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="请输入邮箱"
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">密码</label>
          <input
            type="password"
            className="form-input"
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            placeholder="请输入密码"
            required
          />
        </div>

        <button 
          type="submit" 
          className="btn btn-primary" 
          style={{ width: '100%', marginTop: '16px' }}
          disabled={loading}
        >
          {loading ? '登录中...' : '登录'}
        </button>

        <p style={{ marginTop: '16px', textAlign: 'center', color: '#666' }}>
          还没有账号？ <Link to="/register" style={{ color: '#1890ff' }}>立即注册</Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
